import { ButtonHTMLAttributes, forwardRef, memo, MouseEvent as ReactMouseEvent } from "react";
import classnames from "classnames";

import { ReactComponent as Clear } from "./images/clear.svg";

import styles from "./style.module.scss";

type ClearButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: (e: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => void,
}
const ClearButton = memo<ClearButtonProps>(forwardRef<HTMLButtonElement, ClearButtonProps>(((
  {
    className, ...props
  }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={classnames(styles.root, className)}
      {...props}
    >
      <Clear width={16} height={16} />
    </button>
  );
})));

export default ClearButton;
